import * as React from "react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Loader } from "semantic-ui-react";

import { isRequestActive } from "redux-request-loading";

import { ApplicationState } from "../../../applicationState";

import { teamsSelector } from "../selectors";
import { loadCustomerTeams } from "../actions";
import { selectors as customerSelectors } from "../../customer";

import { LOAD_CUSTOMERS } from "../../customer/actiontypes";

import { All } from "./All";
import { Create } from "./Create";
import { Details } from "./Details";
import { Edit } from "./Edit";

import { Fragment, Location } from "redux-little-router";

export const Base = () => {
    const isRoot = React.useCallback((l: Location) => l.params?.teamId === undefined, []);
    const teams = useSelector(teamsSelector);
    const dispatch = useDispatch();
    const customerId = useSelector(customerSelectors.routeIdSelector);
    React.useEffect(() => {
        if (teams !== undefined) { return undefined; }
        const abortController = new AbortController();
        dispatch(loadCustomerTeams(customerId, abortController));
        return () => abortController.abort();
    }, [dispatch, customerId, teams]);
    const isCustomersLoading = useSelector<ApplicationState>(state => isRequestActive(state, LOAD_CUSTOMERS));
    if (teams === undefined || isCustomersLoading) {
        return <Loader active />;
    }

    return (
        <>
            <Fragment forRoute="/create">
                <Create teams={teams} />
            </Fragment>
            <Fragment forRoute="/" withConditions={isRoot}>
                <All />
            </Fragment>
            <Fragment forRoute="/:teamId">
                <>
                    <Details />
                    <Fragment forRoute="/edit">
                        <Edit teams={teams} />
                    </Fragment>
                </>
            </Fragment>
        </>
    );
};
